import { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import isUndefined from 'lodash-es/isUndefined';

import { withRuntimeConfigServerSideProps } from '@catawiki/next-config/runtime-config';
import { InternalLocale } from '@catawiki/locale';
import { AssetsTheme } from '@catawiki/runtime-toolkit';

import {
  RegisterPage,
  RegisterPageProps,
} from '@/pages/RegisterPage/RegisterPage';
import { getUserAuthentication } from '@/shared/helpers/api/getUserAuthentication';
import { getLayoutAssetsServerSide } from '@/shared/utils/server/getLayoutAssetsServerSide';

const getServerSidePropsInner: GetServerSideProps<RegisterPageProps> = async (
  context
) => {
  const { locale = InternalLocale.ENGLISH } = context;

  const auth = await getUserAuthentication(context);

  const [{ assetData, units }, translations] = await Promise.all([
    getLayoutAssetsServerSide(context, locale, AssetsTheme.SELLER),
    serverSideTranslations(locale),
  ]);

  const APP_IMGPROXY_HOST = process.env.APP_IMGPROXY_HOST;
  if (isUndefined(APP_IMGPROXY_HOST)) {
    throw new Error(
      'The APP_IMGPROXY_HOST is missing. Did you forget to update your .env with the latest values from the vault?'
    );
  }

  return {
    props: {
      isUserLoggedIn: auth.isAuthenticated,
      APP_IMGPROXY_HOST,
      ...(assetData ? { assetsData: assetData } : {}),
      locale,
      pageType: 'sellerRegister',
      showCookieBanner: true,
      ...(units ? { units } : {}),
      ...translations,
    },
  };
};

export const getServerSideProps = withRuntimeConfigServerSideProps(
  getServerSidePropsInner
);

export default RegisterPage;
